import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import _ from 'lodash'
import { ListTable } from 'gnos-tables'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

@hocBlock(config.modules.report.key)
export default class Certificates extends Component {
    static propTypes = {
        transformedData: PropTypes.object,
    }

    renderCertificatesTable = () => {
        const { transformedData } = this.props
        const certificatesTable = _.get(transformedData, 'certificatesTable', {})
        const rowsCount = _.get(transformedData, 'rowsCount', 0)

        return (
            <ListTable
                id={'CertificatesListTable'}
                staticData={certificatesTable}
                columnsDefinition={{
                    title: {
                        Cell: () => (
                            <span style={{ color: '#666' }}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.certificate`} />
                            </span>
                        ),
                        width: 200,
                    },
                    top: {
                        visibleRows: rowsCount,
                        columns: [
                            {
                                accessor: 'text',
                                Cell: ({ value }) => (
                                    <div>
                                        <div>{value.name}</div>
                                        <div style={!value.publisher ? { display: 'none' } : { color: '#707070' }}>
                                            <FormattedMessage id={`${LOCALE_PREFIX}.publisher`} /> {value.publisher}
                                        </div>
                                    </div>
                                ),
                            },
                        ],
                    },
                }}
            />
        )
    }

    render() {
        return <div className={cx('block-certificates')}>{this.renderCertificatesTable()}</div>
    }
}
